export default {
      id: "attention-Yellow-usage",
      viewBox: "0 0 15 15",
      url: __webpack_public_path__ + "img/icons.df114aed.svg#attention-Yellow",
      toString: function () {
        return this.url;
      }
    }